import { useState } from 'react';

const useRoomsTableHook = ({ rooms, onAddRoom }) => {
  const [state, setState] = useState({
    rooms,
    tableControls: rooms.map(({ type }) => ({
      type,
      adults: 0,
      children: 0,
      quantity: 0,
    })),
  });

  const actions = {
    handleAddBooking: ({ index }) => {
      const { adults, children, quantity } = state.tableControls[index];
      const updatedControls = [...state.tableControls];
      const currentControls = updatedControls[index];
      currentControls.adults = 0;
      currentControls.children = 0;
      currentControls.quantity = 0;
      onAddRoom({ index, adults, children, quantity });
      updateState({ tableControls: updatedControls });
    },
    onControlChange: ({ index, key, value }) => {
      const updatedControls = [...state.tableControls];
      const currentControls = updatedControls[index];
      currentControls[key] = value;
      updateState({ tableControls: updatedControls });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useRoomsTableHook;
